//@ts-ignore
import { ErrorCodes } from '../../init/proto_client';
const ssoErrorMessages = {
    [ErrorCodes.USER_NOT_FOUND]: 'LOGIN.NOT_FOUND',
    [ErrorCodes.SSO_UNAVAILABLE]: 'LOGIN.SSO_UNAVAILABLE',
};
export default ssoErrorMessages;
